import React, { useState, useEffect } from 'react';
import { costosExpedienteAPI } from '../services/api';

const CostoExtraForm = ({ expedienteId, costo, onSaved, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    monto: '',
    detalle: ''
  });

  const isEdit = Boolean(costo?.id);

  useEffect(() => {
    if (costo) {
      setFormData({
        monto: costo.monto != null ? String(costo.monto) : '',
        detalle: costo.detalle || ''
      });
    }
  }, [costo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const monto = parseFloat(formData.monto);
      const detalle = formData.detalle.trim();

      if (!detalle) {
        throw new Error('El detalle es obligatorio');
      }
      if (!Number.isFinite(monto) || monto <= 0) {
        throw new Error('El monto debe ser mayor a 0');
      }

      const payload = { monto, detalle };

      if (isEdit) {
        await costosExpedienteAPI.updateCosto(costo.id, payload);
      } else {
        await costosExpedienteAPI.createCosto(expedienteId, payload);
      }

      if (onSaved) {
        onSaved();
      }
    } catch (err) {
      const msg =
        err.response?.data?.error ||
        err.message ||
        'Error al guardar el costo adicional';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="costo-extra-form-inline" style={{
      background: '#f8f9fa',
      borderRadius: '10px',
      padding: '1rem',
      marginBottom: '1rem',
      border: '1px solid #e9ecef'
    }}>
      <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h3 style={{ margin: 0, fontSize: '1.05rem' }}>
          <i className="fas fa-plus-circle" style={{ marginRight: '8px', color: '#0d6efd' }}></i>
          {isEdit ? 'Editar costo adicional' : 'Agregar costo adicional'}
        </h3>
        <button type="button" className="modal-close" onClick={onCancel} aria-label="Cerrar">
          <i className="fas fa-times"></i>
        </button>
      </div>

      {error && (
        <div className="modal-error" style={{ marginBottom: '1rem' }}>
          <i className="fas fa-exclamation-triangle"></i>
          <span>{error}</span>
        </div>
      )}

      <form onSubmit={handleSubmit} className="modal-form">
        <div className="form-group">
          <label htmlFor="detalle-costo" className="form-label">Detalle *</label>
          <input
            type="text"
            id="detalle-costo"
            name="detalle"
            className="form-control modal-input"
            value={formData.detalle}
            onChange={handleChange}
            placeholder="Ej: Visita extra, replanteo..."
            maxLength={500}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="monto-costo" className="form-label">Monto (S/) *</label>
          <input
            type="number"
            id="monto-costo"
            name="monto"
            className="form-control modal-input"
            value={formData.monto}
            onChange={handleChange}
            onWheel={(e) => e.currentTarget.blur()}
            placeholder="0.00"
            step="0.01"
            min="0.01"
            required
          />
        </div>

        <div className="modal-actions">
          <button type="button" className="btn-modal btn-cancel" onClick={onCancel} disabled={loading}>
            Cancelar
          </button>
          <button type="submit" className="btn-modal btn-submit" disabled={loading}>
            {loading ? 'Guardando...' : isEdit ? 'Guardar' : 'Agregar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CostoExtraForm;
